import { render } from "./ProjectForm.vue?vue&type=template&id=1c2b07f2"
import script from "./ProjectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ProjectForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c2b07f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c2b07f2', __exports__)) {
    api.reload('1c2b07f2', __exports__)
  }
  
  module.hot.accept("./ProjectForm.vue?vue&type=template&id=1c2b07f2", () => {
    api.rerender('1c2b07f2', render)
  })

}


export default __exports__